import { Snackbar, AlertTitle, Alert as AlertContainer } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { closeAlert } from '../redux/slices/alerts';
import styled from '@emotion/styled';
import React from 'react';

const SnackbarStyled = styled(Snackbar)(({ theme }) => ({
    left: 'auto',
    right: 'auto',
    bottom: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
        left: 'auto',
        bottom: theme.spacing(3),
        right: theme.spacing(3),
    }
}))

const AlertStyled = styled(AlertContainer)(({ theme }) => ({
    padding: theme.spacing(1, 2),
}));

const TitleStyled = styled(AlertTitle)(({ theme }) => ({
    '&:first-letter': {
        textTransform: 'uppercase',
    },
    fontWeight: theme.typography.fontWeightSemiBold,
}));

const Alert = () => {
    const dispatch = useDispatch();
    const alerts = useSelector(state => state.alerts);

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(closeAlert());
    };

    return (
        <SnackbarStyled open={alerts.alertOpen} autoHideDuration={4000} onClose={handleAlertClose}>
            <AlertStyled onClose={handleAlertClose} severity={alerts.alertSeverity}>
                <TitleStyled>{alerts.alertSeverity}</TitleStyled>
                {alerts.alertMessage}
            </AlertStyled>
        </SnackbarStyled>
    );
};

export default Alert;
